import { useEffect, useMemo, useState } from 'react'
import { usePredictContext } from '../../context/PredictContextProvider'
import { useGetAllTickers } from '../../services/usePredict'


export function usePairSelect() {
    const { ticker, setTicker, responseType, refetch: refetchAnalyze, assistant, predictHistory } = usePredictContext()

    const [search, setSearch] = useState('')
    const [debouncedQuery, setDebouncedQuery] = useState('')
    const [open, setOpen] = useState(false)

    // debounce
    useEffect(() => {
        const timeout = setTimeout(() => setDebouncedQuery(search), 400)
        return () => clearTimeout(timeout)
    }, [search])

    const { data, isFetching, isError, refetch } = useGetAllTickers({
        search: 'ticker',
        query: debouncedQuery,
    })

    const handleSelect = (coin) => {
        if (predictHistory.predictHistoryId) {
            predictHistory.setPredictHistoryId(null)
        }
        setTicker(coin)
        setOpen(false)
        setSearch('')
        refetchAnalyze.setShouldRefetch(true)
    }

    const tickers = useMemo(() => {
        if (isFetching || !data) return []

        const currentCase = assistant?.assistant?.tickerCase

        const filteredTickers = data.filter(item => item.tickerCase === currentCase)

        let list = filteredTickers

        if (debouncedQuery) {
            list = filteredTickers.filter(item =>
                item.ticker.toLowerCase().includes(debouncedQuery.toLowerCase())
            )
        }

        const deduped = Array.from( // Remove duplicated pairs!
            new Map(list.map(item => [item.ticker, item])).values()
        )

        return deduped
    }, [isFetching, data, assistant?.assistant?.tickerCase, debouncedQuery])



    useEffect(() => {
        setTicker('')
    }, [assistant.assistant])

    return {
        ticker,
        search,
        setSearch,
        open,
        setOpen,
        tickers,
        isFetching,
        isError,
        refetch,
        handleSelect,
        responseType
    }
}
